module.exports = __webpack_public_path__ + "img/img_index_logo_white@2x.0e68224e.png";